import { render } from "./PurchaseSplitModal.vue?vue&type=template&id=6d799b6c&scoped=true&ts=true&lang=pug"
import script from "./PurchaseSplitModal.vue?vue&type=script&lang=ts"
export * from "./PurchaseSplitModal.vue?vue&type=script&lang=ts"

import "./PurchaseSplitModal.vue?vue&type=style&index=0&id=6d799b6c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d799b6c"]])

export default __exports__